module.exports = "<div class=\"footer\">\n  <div class=\"footer-copyright\">\n    <p>&copy; {{year}} Nick Smith Consulting</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/jonshilton/Projects/nick-smith-app/src/app/components/footer/footer.component.html
// module id = ../../../../../src/app/components/footer/footer.component.html
// module chunks = 0